import React from 'react';
import { cn } from '@/lib/utils';
import { Loader } from 'lucide-react';

interface LoadingSpinnerProps {
  /** Size variant: 'sm' for inline/small areas, 'md' for sections, 'lg' for full-page */
  size?: 'sm' | 'md' | 'lg';
  /** Additional CSS classes for the outer container */
  className?: string;
  /** Whether to render as a full-page centered overlay */
  fullPage?: boolean;
}

/**
 * Unified loading spinner used across the entire app.
 * Replaces all "Loading...", "...Loading...", and other text-based loading indicators.
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  fullPage = false,
}) => {
  const spinner = (
    <Loader
      className={cn(
        'animate-spin text-muted-foreground',
        'w-8 h-8' // Consistent size everywhere

      )}
    />
  );

  if (fullPage) {
    return (
      <div className={cn('min-h-screen flex items-center justify-center bg-background', className)}>
        {spinner}
      </div>
    );
  }

  return (
    <div className={cn('flex items-center justify-center', className)}>
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
